import styled from 'styled-components';
import PencilSVG from 'icons/edit.svg';

export const Drawer = styled.section`
  width: 100%;
  padding: 1em 0;
`;

export const DrawerSummary = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5em;
  border: 1px solid ${({ theme }) => theme.base.Mystic};
  transition: background-color 150ms ease-in-out;

  &:hover,
  &:focus {
    background-color: white;
  }
`;

export const IconWrapper = styled.div`
  flex: 0 0 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.25em;
`;

export const Title = styled.label`
  flex: 1 0 auto;
  padding: 0.25em 1em;
  font-size: 0.8125em;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: left;
  color: ${({ theme }) => theme.base.PastelBlue};
`;

export const PencilIcon = styled(PencilSVG)`
  stroke: ${({ theme }) => theme.base.PastelBlue};
`;

export const List = styled.ol`
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const EmptyAnnotationArea = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5em;
  border-left: 1px solid ${({ theme }) => theme.base.Mystic};
  border-right: 1px solid ${({ theme }) => theme.base.Mystic};
  border-bottom: 1px solid ${({ theme }) => theme.base.Mystic};
`;



// WEBPACK FOOTER //
// ./src/components/Annotations/Annotations.style.js